import React from 'react';
import { Translate } from 'react-localize-redux';

export default (values) => {
  const errors = {};
  const requiredFields = ['email', 'password'];
  for (const field of requiredFields) {
    if (!values[field]) {
      errors[field] = <Translate id="central.required" />;
    }
  }

  // Pour login avec username
  // if (
  //   values.email &&
  //   !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  // ) {
  //   errors.email = <Translate id="email.invalidEmail" />;
  // }
  if (values.password) {
    if (
      !/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){8,100}$/i.test(
        values.password,
      )
    ) {
      errors.password = <Translate id="email.checkPassword" />;
    }
  }
  return errors;
};
